import { render } from "./AdminCalendar.vue?vue&type=template&id=60030da0"
import script from "./AdminCalendar.vue?vue&type=script&lang=js"
export * from "./AdminCalendar.vue?vue&type=script&lang=js"

import "./AdminCalendar.vue?vue&type=style&index=0&id=60030da0&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__